import React, { Component } from 'react';
import Home from './Home'

class App extends Component {
  state = {  } 
  render() { 
    return (
      <div>
        <Home/>
      </div>
    );
  }
}
 
export default App;